/**
 * Marker string used to indicate "System Default" device selection.
 * This value is used in IPC communication between frontend and backend.
 * Using a special marker avoids conflicts with actual device names.
 *
 * IMPORTANT: This value must match SYSTEM_DEFAULT_DEVICE_MARKER in
 * src-tauri/src/audio/cpal_audio/cpal_utils.rs
 */
export const SYSTEM_DEFAULT_DEVICE_MARKER = '__SYSTEM_DEFAULT__';

/**
 * Prefix for process loopback device names (e.g. "__PROCESS__:1234").
 * Must match PROCESS_LOOPBACK_PREFIX in src-tauri.
 */
export const PROCESS_DEVICE_PREFIX = '__PROCESS__:';

/**
 * Marker string for Windows whole-system speaker capture: all system audio
 * except Heidi's own process tree, via WASAPI Application Loopback in
 * EXCLUDE mode. Sent as the output device name at recording start when the
 * `release-apps-windows-system-audio-capture-desktop` flag is ON — see
 * `resolveDeviceNamesForStart`.
 *
 * IMPORTANT: This value must match SYSTEM_WIDE_DEVICE_MARKER in
 * src-tauri/src/audio/cpal_audio/cpal_utils.rs
 */
export const SYSTEM_WIDE_DEVICE_MARKER = '__SYSTEM_WIDE__';
